import { computed } from 'vue';
import { useFlag } from '@loadsmart/vue-feature-flags';

export const PREPARATION_APPOINTMENTS_FEATURE_FLAG = 'enable-preparation-appointments';

export function usePreparationAppointmentsFeature() {
  const flag = useFlag(PREPARATION_APPOINTMENTS_FEATURE_FLAG);

  const isPreparationAppointmentsReady = computed(() => Boolean(flag.value?.ready));

  const isPreparationAppointmentsEnabled = computed(
    () => isPreparationAppointmentsReady.value && Boolean(flag.value?.enabled)
  );

  return {
    isPreparationAppointmentsEnabled,
    isPreparationAppointmentsReady
  };
}
